import { UserState } from './types';
import { UserAction } from './actions';
import { initialState } from './constants';

export function userReducer(state: UserState = initialState, action: UserAction) {
    return state;
}